import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy} from '../../../../../../../../utils/Functions';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {
    const { gl } = useThree ();

    const wallThickness = 0.005;
    const offsetWithDoorThickness = 0.127;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement !== undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    const isEqualHeight = (params.lean_p_h + ((params.b_l_t_r_p / 12) * (params.lean_p_w)) == params.p_h) ? 0.2 : 0;
    let offset;

    const textureObj = useMemo(() => {
        let similarSidingTextures = getSimilarTexture(params.wallTexture)
        let similarWainscotTextures = getSimilarTexture(params.wainscotTexture)

        const texture = const_var.wallTextureObj?.[similarSidingTextures]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[similarWainscotTextures]?.clone();

        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = Math.PI/-2;
            else metalTexture.rotation = 0;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanR_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;
   
    // Storage Front Wall - CSG
    const storageFrontWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;

        //************************* */ main wall geometry

        let verticalHorizontalPosStorageF = {"x": params.p_w/2,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.leanR_p_d / -2 + parseInt(params.add_storage_right) + wallThickness + 0.03}
        let verticalHorizontalRotStorageF = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        let patternLengthStorageF = params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0)
        let patternDepthStorageF = params.leanR_p_w

        const storageFrontWallModel = new THREE.Shape();
        // if (params.p_b_c_b_r_f !== 'Open' || typeof(params.p_b_c_b_r_f) === 'object') {
            if (params.p_r_s === 1) {
                storageFrontWallModel.moveTo(-(params.leanR_p_w - wallThickness), 0);
                storageFrontWallModel.lineTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h);
                storageFrontWallModel.lineTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h + const_var.roofRegularDst);
                storageFrontWallModel.quadraticCurveTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                                -(params.leanR_p_w - wallThickness - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
                storageFrontWallModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w - wallThickness) + const_var.roofRegularDst * (2)));
                storageFrontWallModel.lineTo(0, 0);
                storageFrontWallModel.closePath();
            } else {
                storageFrontWallModel.moveTo(-params.leanR_p_w + offsetWithDoorThickness - 0.12, params.leanR_p_h);
                storageFrontWallModel.lineTo(0, params.leanR_p_h + params.leanR_p_w / 12 * params.b_l_t_r_pR - isEqualHeight);
                storageFrontWallModel.lineTo(0, 0);
                storageFrontWallModel.lineTo(-params.leanR_p_w + offsetWithDoorThickness - 0.12, 0);
                storageFrontWallModel.closePath();
            }
        // }   
    
        const meshStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageF, isPattern), extrudeSettings(patternDepthStorageF)))  
        const meshFrontStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageFrontWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageFrontWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshStorageWallModel_Temp = meshStorageWallModel.clone();
        meshStorageWallModel_Temp.position.set(verticalHorizontalPosStorageF.x,verticalHorizontalPosStorageF.y,verticalHorizontalPosStorageF.z);
        meshStorageWallModel_Temp.rotation.set(verticalHorizontalRotStorageF.x,verticalHorizontalRotStorageF.y,verticalHorizontalRotStorageF.z);
        meshStorageWallModel_Temp.updateMatrixWorld();
    
        let meshFrontStorageWallModel_Temp = meshFrontStorageWallModel.clone();
        meshFrontStorageWallModel_Temp.rotateY(Math.PI)
        meshFrontStorageWallModel_Temp.position.set(params.p_w / 2, 0, -params.leanR_p_d / 2 + parseInt(params.add_storage_right) + 0.5 )
        meshFrontStorageWallModel_Temp.updateMatrixWorld();
        
        let meshFrontStorageInnerWallModel_Temp = meshFrontStorageInnerWallModel.clone();
        meshFrontStorageInnerWallModel_Temp.rotateY(Math.PI)
        meshFrontStorageInnerWallModel_Temp.position.set(params.p_w / 2, 0, -params.leanR_p_d / 2 + parseInt(params.add_storage_right))
        meshFrontStorageInnerWallModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set(0, 0, parseInt(params.add_storage_right) - 0.5 -params.leanR_p_d / 2);
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.25, 0, -params.leanR_p_pos - params.rightLeanStoragePosition);
        meshSideDelModel_Temp.rotateY(Math.PI / 2)
        meshSideDelModel_Temp.updateMatrixWorld();
    
        const meshFrontStorageWallModel_CSG = CSG.fromMesh(meshFrontStorageWallModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshStorageWallModel_CSG = CSG.fromMesh(meshStorageWallModel_Temp);
        const meshStorageInnerWallModel_CSG = CSG.fromMesh(meshFrontStorageInnerWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

    
        const frontStorageWallModel_CSG =  meshFrontStorageWallModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const frontStorageInnerWallModel_CSG =  meshStorageInnerWallModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageWallModel_CSG = meshStorageWallModel_CSG.intersect(frontStorageWallModel_CSG);
        const storageSideInnerWallDelModel_CSG = frontStorageInnerWallModel_CSG.subtract(meshSideDelModel_CSG);
        const storageSideWallDelModel_CSG = storageWallModel_CSG.subtract(meshSideDelModel_CSG);


        const CSGFrontStorageWallModel = CSG.toMesh( storageSideWallDelModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGFrontStorageInnerWallModel = CSG.toMesh( storageSideInnerWallDelModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))

        mainWall = CSGFrontStorageWallModel.geometry
        innerWall = CSGFrontStorageInnerWallModel.geometry

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosStorageF = {"x": params.p_w/2,"y" : 0, "z" : params.leanR_p_d / -2 + parseInt(params.add_storage_right) + wallThickness + 0.03 + 0.03}
        let wainscotVerticalHorizontalRotStorageF = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}

        let lengthPatternStorageF = 3
        let depthPatternStorageF = patternDepthStorageF

        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageF, isPattern), extrudeSettings(depthPatternStorageF))) 
        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageF.x,wainscotVerticalHorizontalPosStorageF.y,wainscotVerticalHorizontalPosStorageF.z);
        meshStorageFrontWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageF.x,wainscotVerticalHorizontalRotStorageF.y,wainscotVerticalHorizontalRotStorageF.z);
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);

        const storageFrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageSideDelModel_CSG = storageFrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(storageSideDelModel_CSG, new THREE.Matrix4())

        wainscotWall = CSGStorageFrontWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}

    }, [params.add_storage_right, params.leanR_p_d, params.rightLeanStoragePosition, params.p_v_w, params.p_w, params.p_b_c_b_r_f, params.leanR_p_pos, params.p_r_s, params.leanR_p_w, params.b_l_t_r_pR, params.leanR_p_h, params.p_w_c_n, const_var.newDoorsArray, params.p_w_c_n, params.add_storage_check_right, isPattern]);
    
    return (
        <>
            {storageFrontWallModelObj && storageFrontWallModelObj?.mainWall &&
                <mesh name="R_L_F_S_W" geometry={storageFrontWallModelObj?.mainWall} position={[0, 0, offset]} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }

            {storageFrontWallModelObj && storageFrontWallModelObj?.innerWall &&
                <mesh name="storage" geometry={storageFrontWallModelObj?.innerWall} position={[0, 0, -wallThickness + offset - 0.01]}>
                    <MaterialInnerWall texture={texture} visibleSection={"rightLean"} />
                </mesh>
            }

            {/* Storage Front Wainscot */}
            {params.p_w_c_n == true && storageFrontWallModelObj && storageFrontWallModelObj?.wainscotWall &&
                <mesh name="R_L_F_S_W_wainscot" geometry={storageFrontWallModelObj?.wainscotWall} position={[0,0,0.005 + offset]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel